/**
 * Indicates the state of the plan context
 */ export var ContextState = /*#__PURE__*/ function(ContextState) {
    ContextState["Active"] = "active";
    ContextState["Delinked"] = "delinked";
    return ContextState;
}({});
